"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../tools/utils");
var utils_2 = require("../utils");
var button_1 = require("./button");
var TOGGLE_DELAY = 150;
/**
 * selectButton 基类
 * 在下拉菜单中，无tooltip，无showName，由renderIcon去提供
 * - @type {() => JSX.Element} renderIcon 渲染按钮
 * - @type {() => JSX.Element} renderMenu 渲染菜单
 * - @type {() => boolean} checkActive 按钮是否需要高亮
 */
var SelectBase = /** @class */ (function (_super) {
    __extends(SelectBase, _super);
    function SelectBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuRef = react_1.default.createRef();
        _this.shouldClose = false; // 鼠标移动时标志位，判断要不要关闭菜单
        _this.state = {
            open: false,
            tooltipShow: false
        };
        _this.tendToCloseMenu = function (level) {
            if (level === void 0) { level = 1; }
            _this.shouldClose = true;
            setTimeout(function () {
                _this.shouldClose && _this.closeMenu();
            }, TOGGLE_DELAY / level);
        };
        _this.getTriggerHandler = function () {
            var triggerHandler = {};
            var _a = _this.props, toolbar = _a.toolbar, editor = _a.editor;
            if (toolbar && toolbar.disable && toolbar.disable(editor)) {
                return triggerHandler;
            }
            if (_this.eventType !== 'click') {
                triggerHandler.onMouseEnter = function () { return _this.openMenu(); };
                triggerHandler.onMouseLeave = function () { return _this.tendToCloseMenu(); };
            }
            else {
                triggerHandler.onClick = function (e) {
                    _this.state.open ? _this.closeMenu() : _this.openMenu();
                    e.stopPropagation();
                };
            }
            return triggerHandler;
        };
        // 点击菜单外的其他地方要关闭
        _this.checkClose = function (e) {
            if (!_this.wrap || !_this.menuRef.current)
                return;
            if (!_this.state.open)
                return;
            if (_this.menuRef.current.contains(e.target))
                return;
            _this.tendToCloseMenu(6);
        };
        _this.openMenu = function () {
            _this.shouldClose = false;
            if (_this.state.open)
                return;
            setTimeout(function () {
                _this.setState({ open: true, tooltipShow: false });
                document.addEventListener('scroll', _this.updatePosition);
                document.addEventListener('click', _this.checkClose, true);
            }, _this.eventType !== 'click' ? TOGGLE_DELAY / 2 : 0);
        };
        _this.closeCallBack = function () { };
        _this.closeMenu = function () {
            if (!_this.state.open)
                return;
            _this.setState({ open: false }, _this.closeCallBack);
            document.removeEventListener('scroll', _this.updatePosition);
            document.removeEventListener('click', _this.checkClose, true);
        };
        _this.updatePosition = function () { return requestAnimationFrame(function () { return _this.forceUpdate(); }); };
        _this.showTooltip = function () {
            if (!_this.state.open && !_this.state.tooltipShow) {
                _this.setState({ tooltipShow: true });
            }
        };
        _this.hideTooltip = function () {
            if (!_this.state.open && _this.state.tooltipShow) {
                _this.setState({ tooltipShow: false });
            }
        };
        _this.checkActive = function () { return false; };
        _this.renderIcon = function () { return react_1.default.createElement("span", null); };
        _this.renderMenu = function () { };
        _this.renderMenuList = function () {
            var _a;
            var _b = _this.props.toolbarType, toolbarType = _b === void 0 ? 'static' : _b;
            return (react_1.default.createElement(utils_1.List, { className: classnames_1.default((_a = {},
                    _a[toolbarType] = toolbarType,
                    _a)), getRef: _this.menuRef, onClick: _this.closeMenu }, _this.renderMenu()));
        };
        return _this;
    }
    Object.defineProperty(SelectBase.prototype, "eventType", {
        get: function () {
            var _a = this.props, display = _a.display, trigger = _a.trigger, toolbarType = _a.toolbarType;
            if (trigger) {
                return trigger === 'click' ? 'click' : 'mousemove';
            }
            if (toolbarType === 'inline')
                return 'mousemove';
            if (display === utils_2.ToolDisplay.VERTICAL)
                return 'click';
            return 'mousemove';
        },
        enumerable: true,
        configurable: true
    });
    SelectBase.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, _c = _b.name, name = _c === void 0 ? '' : _c, tooltip = _b.tooltip, editor = _b.editor, _d = _b.tipDirection, tipDirection = _d === void 0 ? 'up' : _d, _e = _b.tipDistance, tipDistance = _e === void 0 ? 4 : _e, _f = _b.toolbarType, toolbarType = _f === void 0 ? 'static' : _f, _g = _b.menuDistance, menuDistance = _g === void 0 ? 4 : _g, _h = _b.menuDirection, menuDirection = _h === void 0 ? 'down-start' : _h, toolbar = _b.toolbar, display = _b.display;
        var _j = this.state, open = _j.open, tooltipShow = _j.tooltipShow;
        return (react_1.default.createElement(button_1.ButtonForToolbar, { display: display, tipDirection: tipDirection, tipDistance: tipDistance, toolbarType: toolbarType, name: name, toolbar: __assign(__assign({}, toolbar), { showName: display === utils_2.ToolDisplay.VERTICAL ? (_a = toolbar) === null || _a === void 0 ? void 0 : _a.showName : false, icon: function () {
                    var _a;
                    return (react_1.default.createElement(utils_1.Popper, { isOpen: Boolean(open), tipContentClassName: classnames_1.default((_a = {}, _a[name] = name, _a)), content: _this.renderMenuList(), 
                        // eventToggle={'onClick'} 不使用的原因是不好处理tooltip与popper之间的关系
                        distance: (toolbar && toolbar.menuDistance) || menuDistance, 
                        // 默认'down-start'，在下拉菜单中'right-start'
                        direction: (toolbar && toolbar.menuDirection) ||
                            display === utils_2.ToolDisplay.VERTICAL
                            ? menuDirection
                            : 'right-start' },
                        react_1.default.createElement("span", null, _this.renderIcon())));
                } }), getRef: function (wrap) {
                _this.wrap = wrap;
            }, tooltip: display === utils_2.ToolDisplay.VERTICAL ? tooltip : false, active: this.checkActive(), handler: function () { return (_this.state.open ? _this.closeMenu() : _this.openMenu()); }, editor: editor, attrs: false, tooltipProps: { isOpen: open ? false : tooltipShow }, buttonProps: __assign({ onMouseEnter: this.showTooltip, onMouseLeave: this.hideTooltip }, this.getTriggerHandler()), className: open ? 'open' : '' }));
    };
    return SelectBase;
}(react_1.default.Component));
exports.SelectBase = SelectBase;
//# sourceMappingURL=base.js.map